import { createSlice } from "@reduxjs/toolkit"
import { DropdownObj } from "../Common/commonTypes"

type DispatchRequestFormValue = {
    age_op: string
    age: any
    more_than_age: string
    between_age1: string
    between_age2: string
    less_than_age: string
    assigned_to: Record<string, any>
    tags: any
    TicketStartDate: string
    TicketEndDate: string
    search_key: string
    ticketType: string
    parent_status: string
    queryByIds: number[]
    requested_delivery_date_from: string
    requested_delivery_date_to: string
    on_hold: any
    on_hold_date: string
    on_hold_reason_ids: number[]
    destination_site_ids: DropdownObj[]
    template_id: any
    category_ids: DropdownObj[]
    product_ids: any
    statusId: any
}

type InitialState = {
    DispatchRequestFormValue: DispatchRequestFormValue
    page: number
    selectedValue: number
    selectedTab: number
    selectedMetric: any[]
    metricExplicitlyCleared: boolean
    displayValues: any[]
    currentRules: any[]
    ticketId: string
}

const initialState: InitialState = {
    DispatchRequestFormValue: {
        age_op: "",
        age: [],
        more_than_age: "",
        between_age1: "",
        between_age2: "",
        less_than_age: "",
        assigned_to: {},
        tags: [],
        TicketStartDate: "",
        TicketEndDate: "",
        search_key: "",
        ticketType: "all",
        parent_status: "all",
        queryByIds: [],
        requested_delivery_date_from: "",
        requested_delivery_date_to: "",
        on_hold: null,
        on_hold_date: "",
        on_hold_reason_ids: [],
        destination_site_ids: [],
        template_id: [],
        category_ids: [],
        product_ids: [],
        statusId: [],
    },
    page: 1,
    selectedValue: 10,
    selectedTab: 0,
    selectedMetric: [],
    metricExplicitlyCleared: false,
    displayValues: [],
    currentRules: [],
    ticketId: "",
}

const DispatchRequestSlice = createSlice({
    name: "dispatchRequest",
    initialState,
    reducers: {
        setDispatchRequestForm: (state, action) => {
            state.DispatchRequestFormValue = action?.payload
        },
        setPages: (state, action) => {
            state.page = action?.payload
        },
        setSelectedValues: (state, action) => {
            state.selectedValue = action?.payload
        },
        setSelectedTab: (state, action) => {
            state.selectedTab = action?.payload
        },
        setSelectedMetric: (state, action) => {
            state.selectedMetric = action?.payload
        },
        setMetricExplicitlyCleared: (state, action) => {
            state.metricExplicitlyCleared = action?.payload
        },
        setDisplayValues: (state, action) => {
            state.displayValues = action?.payload
        },
        setCurrentRuleValue: (state, action) => {
            state.currentRules = action?.payload
        },
        setTicketId: (state, action) => {
            state.ticketId = action?.payload
        },
        resetDispatchRequestFilters: state => {
            state.DispatchRequestFormValue = initialState.DispatchRequestFormValue
            state.page = 1
            state.selectedValue = 10
            state.selectedTab = 0
            state.selectedMetric = []
            state.metricExplicitlyCleared = false
            state.displayValues = []
            state.currentRules = []
        },
    },
})

export const {
    setDispatchRequestForm,
    setPages,
    setSelectedValues,
    setSelectedTab,
    setSelectedMetric,
    setMetricExplicitlyCleared,
    setDisplayValues,
    setCurrentRuleValue,
    setTicketId,
    resetDispatchRequestFilters,
} = DispatchRequestSlice.actions

export default DispatchRequestSlice.reducer
